<mat-nav-list>
  <div mat-subheader>Patients</div>
  <a *ngFor="let patient of patients$ | async; trackBy: trackByFn"
    mat-list-item
    routerLink="/patients/{{ patient.id }}"
    routerLinkActive="active"
    (click)="patientSelected.emit()">
    <app-avatar matListAvatar icon="pets" [src]="patient.profilePicture?.downloadURL" [path]="patient.profilePicture?.path"></app-avatar>
    <div mat-line>{{ patient.name | titlecase }}</div>
    <div *ngIf="patient.ownerName as ownerName" mat-line>{{ ownerName | titlecase }}</div>
  </a>
</mat-nav-list>